import "./comparison-table.css";

interface ComparisonRow {
  feature: string;
  budgetFacility: string | JSX.Element;
  midTierPractice: string | JSX.Element;
  celebrityPractice: string | JSX.Element;
  topAesthetics: string | JSX.Element;
}

interface ComparisonTableProps {
  rows: ComparisonRow[];
  title?: string;
}

const DesktopTable = ({ rows }: { rows: ComparisonRow[] }) => (
  <div className="comparison-table-scroll">
    <table className="comparison-table-desktop">
      <colgroup>
        <col className="comparison-col-feature" />
        <col className="comparison-col-value" />
        <col className="comparison-col-value" />
        <col className="comparison-col-value" />
        <col className="comparison-col-value" />
      </colgroup>
      <thead>
        <tr>
          <th className="feature-header">Feature</th>
          <th>Budget Facility</th>
          <th>Mid-Tier Practice</th>
          <th>Celebrity Practice</th>
          <th>Top Aesthetics</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx} className={idx % 2 === 0 ? "even-row" : "odd-row"}>
            <td className="feature-cell">
              <strong>{row.feature}</strong>
            </td>
            <td className="value-cell">{row.budgetFacility}</td>
            <td className="value-cell">{row.midTierPractice}</td>
            <td className="value-cell">{row.celebrityPractice}</td>
            <td className="value-cell highlight">{row.topAesthetics}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const ComparisonTable = ({
  rows,
  title = "The Surgical Center Landscape",
}: ComparisonTableProps) => {
  return (
    <div className="comparison-table-container">
      {/* <h2 style={{ marginBottom: "20px", textAlign: "center" }}>{title}</h2> */}
      <DesktopTable rows={rows} />
    </div>
  );
};

export default ComparisonTable;
